<template>
    <section class="mm-section mm-section__banner mm-section mm-section__banner--static"
        :style="{/*
            backgroundImage: `url(${imageName})`,
            backgroundPosition: 'right'
        */}">
        <img
            class="mm-section__banner-img"
            v-if="imageName"
            :src="imageName.src"
            :srcset="imageName.srcset"
        />

        <div class="mm-section-content mm-section-content--desktop-cols  mm-section-content--wider">
            <div class="mm-section__col mm-section__col--centered mm-section__banner-info">
                <div class="headline headline--white">
                    {{title}}
                </div>
                <div class="text--bigger-paragraph text--white">
                    {{description}}
                </div>
            </div>
            <div class="mm-section__col">
                <SearchBox
                    formClass="mm-section__banner--searching-wrapper"
                    inputClass="searchbox-input--mm searchbox-input--mm-banner"
                    iconClass="hidden"
                    outerWrapperClassname="mm-section__banner--searching"
                    resultsClass="searchbox__results searchbox__results--banner-rounded"
                    :placeholderText="$t('UI.banners.searchPlaceholder')"
                    :apiSearchOperation="searchFulltext"
                    :onSelectItem="onSelectItem"
                    :minSearchValLength="3"
                    :transform="res => res.map(item => {
                        item.text = item.displayName;
                        return item;
                    })">
                    <template v-slot:afterInputSlot>
                        <button
                            @click="openMap"
                            type="button"
                            class="button main--button mm-section__banner--searching-button">
                            vstúpte do mapy
                        </button>
                    </template>
                </SearchBox>
            </div>
        </div>
    </section>
</template>

<script>
import SearchBox from '@/components/searchApi';
import { searchFulltext, openSearchResult, openMap } from '@/services/MapsfyApi';

export default {
    components: {
        SearchBox
    },
    props: {
        imageName: {
            type: String,
            required: true
        },
        title: {
            type: String
        },
        description: {
            type: String
        }
    },
    data() {
        return {
            publicPath: process.env.BASE_URL
        }
    },
    methods: {
        searchFulltext(value) {
            return searchFulltext(value);
        },
        onSelectItem(item) {
            this.$router.push({name: 'mapApp'});
            openSearchResult(item);
        },
        openMap() {
            this.$router.push({name: 'mapApp'});
            openMap();
        }
    }
}
</script>